module.exports = __webpack_public_path__ + "img/home_ic_clouds.80d08bc4.png";